import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import ai_image from '../assets/ai_image.jpg';
import ai_image_third from '../assets/ai_third.jpg';

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqDataFirst = [
  {
    question: 'What is an AI Agent?',
    answer:
      'An AI Agent is an intelligent software assistant that can understand language, automate tasks, answer questions, and interact with users — across channels like web, chat, or email — without human involvement.',
    image:
      ai_image_third 
  },
  {
    question: 'How does an AI Agent learn?',
    answer:
      'AI Agents are powered by large language models and trained on your company’s content, FAQs, documents, and APIs. They continuously improve by learning from interactions (with your permission).',
    image:
      ai_image_third 
  },
  {
    question: 'Where can I deploy my AI Agent?',
    answer:
      'You can deploy AI Agents on websites, mobile apps, WhatsApp, email, social media, Slack, and more — all from a single dashboard.',
    image:
     ai_image_third 
  },
  {
    question: 'Is my data safe with AI Agent?',
    answer:
      'Yes. Your data stays private and is never used to train public models. AI Agent is built with enterprise-grade encryption and full data control.',
    image:
     ai_image_third 
  },
  {
    question: 'What is Generative AI?',
    answer:
      'Generative AI refers to artificial intelligence systems that can create new content, including text, images, code, and more. It uses deep learning models trained on vast amounts of data to generate human-like outputs.',
    image:
      ai_image_third 
  },
  {
    question: 'How does Blockchain work?',
    answer:
      'Blockchain is a distributed ledger technology that records transactions across multiple computers. Each block contains data and is linked to the previous block, creating a secure and transparent chain that cannot be altered.',
    image:
      ai_image_third 
  },
  {
    question: 'What are the benefits of Cloud Computing?',
    answer:
      'Cloud computing offers scalability, cost-efficiency, flexibility, and accessibility. It allows businesses to access computing resources on-demand without maintaining physical infrastructure, enabling faster innovation and growth.',
    image:
      ai_image_third 
      
  }
];

  const faqDataSecond = [
  {
    question: 'What is Generative AI?',
    answer:
      'Generative AI is a type of artificial intelligence that can create new and original content — such as text, images, audio, videos, and even code. It learns patterns from large datasets and uses that knowledge to produce human-like and creative outputs.',
    image: ai_image,
  },
  {
    question: 'How does Generative AI work?',
    answer:
      'Generative AI works using deep learning techniques like neural networks and transformer models. These models analyze massive datasets to understand structure and context, then predict the next element — such as a word, pixel, or sound — to generate realistic and coherent results.',
    image: ai_image,
  },
  {
    question: 'What are the main applications of Generative AI?',
    answer:
      'Generative AI is used in chatbots, content writing tools, design generation, coding assistants, data synthesis, and personalization systems. It supports industries like marketing, healthcare, finance, and entertainment to boost innovation, creativity, and productivity.',
    image: ai_image,
  },
  {
    question: 'What are the benefits of Generative AI?',
    answer:
      'Generative AI improves efficiency by automating repetitive tasks, speeding up content creation, and offering personalized experiences. It also supports brainstorming, rapid prototyping, and data analysis — allowing humans to focus more on strategic and creative work.',
    image: ai_image,
  },
  {
    question: 'What are the challenges of Generative AI?',
    answer:
      'Despite its potential, Generative AI raises challenges around data privacy, bias, and content authenticity. Responsible use with transparency, human oversight, and ethical standards is essential to prevent misinformation and build trust in AI-generated outcomes.',
  image: ai_image,
  },
];


  return (
    <>
    <Container>
         <h3 
            style={{
           
              fontWeight: '700',
              marginBottom: '40px',
              color: 'black',
              textAlign: "center"
            }}
          >
          Your Data. Your AI. Your Advantage.
          </h3>
    <div className="container my-5 py-5">
      <div className="row align-items-center">
        {/* Left Side - FAQ Questions */}
        <div className="col-lg-6 col-md-12">
         

          <div className="accordion" id="faqAccordion">
            {faqDataFirst.map((faq, index) => (
              <div 
                key={index}
                className="mb-3"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '10px',
                  boxShadow: activeIndex === index 
                    ? '0 6px 12px rgba(106, 29, 194, 0.2)' 
                    : '0 2px 8px rgba(0, 0, 0, 0.1)',
                  border: activeIndex === index 
                    ? '2px solid rgba(106, 29, 194, 0.5)' 
                    : '2px solid transparent',
                  transition: 'all 0.3s ease',
                  overflow: 'hidden'
                }}
              >
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${activeIndex === index ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => setActiveIndex(index)}
                    style={{
                      backgroundColor: activeIndex === index ? 'rgba(106, 29, 194, 0.1)' : '#fff',
                      color: activeIndex === index ? '#6A1DC2' : '#333',
                      fontWeight: '600',
                      fontSize: '1.5rem',
                      padding: '20px 25px',
                      border: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {faq.question}
                  </button>
                </h2>
                <div
                  className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}
                >
                  <div 
                    className="accordion-body"
                    style={{
                      padding: '20px 25px',
                      color: '#666',
                      fontSize: '1rem',
                      lineHeight: '1.6'
                    }}
                  >
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side - Image */}
        <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
          <div
            style={{
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
              height: '500px'
            }}
          >
            <img
              src={faqDataFirst[activeIndex].image}
              alt={faqDataFirst[activeIndex].question}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'opacity 0.5s ease-in-out'
              }}
            />
         
          </div>
        </div>
      </div>
    </div>
    </Container>
  
    
    </>
  );
}